module.exports = __webpack_public_path__ + "static/media/pic14.60660ed7.jpg";